import React from 'react';

const useOnWindowClose = (enabled, handler) => {
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
      handler?.(e);
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [
    handler,
    enabled
  ]);
};

export { useOnWindowClose };
//# sourceMappingURL=useOnWindowClose.js.map
